import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { Device, DeviceListParams } from '@repo/user-types'

const initialState: GenericOperationState<Device[] | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: devicesDataActions, reducer: devicesDataReducer } = createOperationSlice<
  Device[] | null,
  SliceCaseReducers<GenericOperationState<Device[] | null>>,
  DeviceListParams
>({
  name: '@users/devices/data',
  initialState,
  reducers: {},
})
